var _circle, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9275_5913",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 18,
    height: 18
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.0002,
    cy: 9.99967,
    r: 8.66667,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9275_5913)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#595959"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70426 11.9411C8.70426 11.3074 8.77588 10.8072 8.91911 10.4404C9.06234 10.0737 9.29454 9.75575 9.61572 9.48665C9.9369 9.21755 10.181 8.97125 10.3481 8.74772C10.5152 8.5242 10.5988 8.27789 10.5988 8.00879C10.5988 7.3534 10.3167 7.02572 9.75244 7.02572C9.49202 7.02572 9.28152 7.1212 9.12093 7.31217C8.96034 7.50315 8.87571 7.76139 8.86702 8.08691H6.6665C6.67518 7.21885 6.94862 6.54286 7.48682 6.05892C8.02501 5.57498 8.78021 5.33301 9.75244 5.33301C10.7203 5.33301 11.4701 5.55653 12.0018 6.00358C12.5335 6.45063 12.7993 7.08648 12.7993 7.91113C12.7993 8.27138 12.7277 8.59907 12.5845 8.89421C12.4412 9.18935 12.2112 9.49099 11.8944 9.79915L11.1457 10.4958C10.933 10.6998 10.7854 10.9092 10.703 11.124C10.6205 11.3389 10.5749 11.6112 10.5662 11.9411H8.70426ZM8.43734 13.9202C8.43734 13.5991 8.55344 13.3354 8.78564 13.1292C9.01785 12.9231 9.30756 12.82 9.65479 12.82C10.002 12.82 10.2917 12.9231 10.5239 13.1292C10.7561 13.3354 10.8722 13.5991 10.8722 13.9202C10.8722 14.2414 10.7561 14.5051 10.5239 14.7113C10.2917 14.9174 10.002 15.0205 9.65479 15.0205C9.30756 15.0205 9.01785 14.9174 8.78564 14.7113C8.55344 14.5051 8.43734 14.2414 8.43734 13.9202Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.e8f33a03385441076647db53264878ca.svg";
export { ForwardRef as ReactComponent };